import { Component, inject, ViewEncapsulation } from '@angular/core';
import { AppComponentBaseDirective } from '@app/shared/directives/app-component-base.directive';
import { LanguageService } from '@app/shared/services/language.service';
import { UserConfigurationService } from '@app/shared/services/user-configuration.service';

@Component({
  selector: 'nw-language-select',
  templateUrl: './language-select.component.html',
  styleUrl: './language-select.component.scss',
})
export class LanguageSelectComponent extends AppComponentBaseDirective {

  private configuration = inject(UserConfigurationService);
  private languageService = inject(LanguageService);

  languages = this.localization.languages.filter(l => !l.isDisabled);
  currentLanguage = this.localization.currentLanguage;

  changeLanguage(languageName: string): void {
    this.languageService.languageCookieValue = languageName;
    this.configuration.refresh();
  }
}
